module.exports = __webpack_public_path__ + "static/img/frontback.45802ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/about/images/frontback.svg
// module id = /es/
// module chunks = 1